// This icon file is generated automatically.

import { IconDefinition } from '../types';

const KycOutlined: IconDefinition = {
  icon: {
    tag: 'svg',
    attrs: {
      fill: 'currentColor',
      viewBox: '0 0 40 40',
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
    },
    children: [
      {
        tag: 'path',
        attrs: {
          'clip-rule': 'evenodd',
          d: 'M3.5 14v-4A6.5 6.5 0 0 1 10 3.5h4a1.5 1.5 0 0 0 0-3h-4A9.5 9.5 0 0 0 .5 10v4a1.5 1.5 0 0 0 3 0M26 3.5h4a6.5 6.5 0 0 1 6.5 6.5v4a1.5 1.5 0 0 0 3 0v-4A9.5 9.5 0 0 0 30 .5h-4a1.5 1.5 0 0 0 0 3M.5 26v4a9.5 9.5 0 0 0 9.5 9.5h4a1.5 1.5 0 0 0 0-3h-4A6.5 6.5 0 0 1 3.5 30v-4a1.5 1.5 0 0 0-3 0M26 39.5h4a9.5 9.5 0 0 0 9.5-9.5v-4a1.5 1.5 0 0 0-3 0v4a6.5 6.5 0 0 1-6.5 6.5h-4a1.5 1.5 0 0 0 0 3M25.5 13v2a1.5 1.5 0 0 0 3 0v-2a1.5 1.5 0 0 0-3 0M11.5 13v2a1.5 1.5 0 0 0 3 0v-2a1.5 1.5 0 0 0-3 0M19.5 21.07V16a1.5 1.5 0 0 1 3 0v6a1.5 1.5 0 0 1-.83 1.34l-2 1a1.5 1.5 0 1 1-1.34-2.68zM25.94 25.94a1.5 1.5 0 0 1 2.12 2.12c-.27.27 0 0 0 0a11.4 11.4 0 0 1-16.12 0 1.5 1.5 0 0 1 2.12-2.12c.27.27 0 0 0 0a8.4 8.4 0 0 0 11.88 0',
          'fill-rule': 'evenodd',
        },
      },
    ],
  },
  name: 'kyc',
  theme: 'outlined',
};

export default KycOutlined;
